export default __webpack_public_path__ + "static/media/good.fe0cc89e.svg";